module.exports = __webpack_public_path__ + "static/img/15.d93bd04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15.jpg
// module id = 286
// module chunks = 0